import React from 'react';

import {cn} from '../lib/helpers';

import {logoStyle} from './logo.module.css';

const Logo = ({className, ...rest}) => (
  <div className={cn(logoStyle, className)} {...rest}>
    UrakkaDiili
  </div>
);

export default Logo;
